'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../../utils/underscore');

var _ActiveElement = require('../../core/ActiveElement');

var _KeyCodes = require('../../constants/KeyCodes');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactUtils = require('react-utils');

var _UIButton = require('../../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIClickable = require('../../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _ComponentWithWindowListeners = require('../../mixins/ComponentWithWindowListeners');

var _ComponentWithWindowListeners2 = _interopRequireDefault(_ComponentWithWindowListeners);

var _UIIcon = require('../../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _EventHandlers = require('../../core/EventHandlers');

var _HideFocusOnClick = require('../../utils/HideFocusOnClick');

var _HideFocusOnClick2 = _interopRequireDefault(_HideFocusOnClick);

var _UIPopover = require('../../tooltip/UIPopover');

var _UIPopover2 = _interopRequireDefault(_UIPopover);

var _UIPopoverArrow = require('../../tooltip/UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _UIDropdownCaret = require('../UIDropdownCaret');

var _UIDropdownCaret2 = _interopRequireDefault(_UIDropdownCaret);

var _customRenderer = require('../../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _PlacementConstants = require('../../tooltip/PlacementConstants');

var _Tether = require('../../constants/Tether');

var _Functions = require('../../core/Functions');

var _iconName = require('../../utils/propTypes/iconName');

var _focusStylesListener = require('../../listeners/focusStylesListener');

var _decorators = require('../../utils/propTypes/decorators');

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractDropdown',

  mixins: [_ComponentWithWindowListeners2.default],

  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnToggle: _react.PropTypes.bool,
    'aria-pressed': _react.PropTypes.bool,
    arrowColor: _react.PropTypes.string,
    arrowSize: _react.PropTypes.oneOf((0, _underscore.keys)(_UIPopoverArrow2.default.ARROW_SIZES)),
    autoPlacement: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['horiz', 'vert'])]).isRequired,
    buttonSize: _UIButton2.default.propTypes.size,
    buttonText: _react.PropTypes.node,
    buttonUse: _UIButton2.default.propTypes.use,
    caretRenderer: CustomRenderer.propType,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    closeOnOutsideClick: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    dropdownClassName: _react.PropTypes.string,
    dropdownContentRef: (0, _decorators.hidden)(_react.PropTypes.func),
    iconName: (0, _iconName.getIconNamePropType)(),
    id: _react.PropTypes.string,
    locked: _react.PropTypes.bool.isRequired,
    menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
    multiline: (0, _decorators.hidden)(_react.PropTypes.bool.isRequired),
    onChangePlacement: _react.PropTypes.func,
    onClick: _react.PropTypes.func,
    onFocusLeave: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onOpenStart: _react.PropTypes.func,
    onWindowKeyDown: (0, _decorators.hidden)(_react.PropTypes.func),
    open: _react.PropTypes.bool,
    pinToConstraint: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]),
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
    popoverProps: _react.PropTypes.object,
    _useMutationObserver: _react.PropTypes.bool,
    _useNativeButton: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: false,
      autoPlacement: 'vert',
      buttonSize: 'default',
      buttonUse: 'secondary',
      caretRenderer: _react2.default.createElement(_UIDropdownCaret2.default, null),
      closeOnOutsideClick: true,
      dropdownClassName: '',
      locked: false,
      multiline: false,
      open: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      controlWidth: 0
    };
  },
  componentWillMount: function componentWillMount() {
    this._dropdownId = (0, _underscore.uniqueId)('dropdown-');
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.controlWidth === this.state.controlWidth) {
      this.measureControlWidth();
    }

    // If the dropdown was closed via the keyboard, and the focus was within the dropdown, then give
    // keyboard focus to the control.
    if (prevProps.open && !this.props.open && this.hasKeyboardFocus() && (0, _focusStylesListener.isPageInKeyboardMode)()) {
      this.focusOnControl();
    }
  },
  measureControlWidth: function measureControlWidth() {
    var controlEl = (0, _reactDom.findDOMNode)(this._controlRef);
    if (controlEl) {
      var controlWidth = this.computeControlWidth(controlEl);
      if (controlWidth !== this.state.controlWidth) {
        this.setState({
          controlWidth: controlWidth
        });
      }
    }
  },
  getControlWidth: function getControlWidth() {
    return Math.max(this.state.controlWidth, _Tether.MIN_MENU_WIDTH);
  },
  getArrowSize: function getArrowSize(_ref) {
    var buttonUse = _ref.buttonUse;

    if (buttonUse.match(/link|transparent/)) {
      return 'medium';
    }
    return 'none';
  },
  getAnimateOnToggle: function getAnimateOnToggle(_ref2, _ref3) {
    var animateOnToggle = _ref2.animateOnToggle;
    var computedArrowSize = _ref3.computedArrowSize;

    if (typeof animateOnToggle === 'boolean') {
      return animateOnToggle;
    }
    return computedArrowSize !== 'none';
  },
  getPlacement: function getPlacement(_ref4, _ref5) {
    var placement = _ref4.placement;
    var computedArrowSize = _ref5.computedArrowSize;

    if (placement) {
      return placement;
    }
    // Center if we have an arrow, otherwise flush left against the target
    if (computedArrowSize !== 'none') {
      return 'bottom';
    }
    return 'bottom right';
  },
  getDistanceAdjustment: function getDistanceAdjustment(_ref6) {
    var buttonSize = _ref6.buttonSize,
        buttonUse = _ref6.buttonUse;

    if (buttonUse === 'transparent') {
      // Account for invisible padding
      var buttonPaddingY = void 0;
      if (buttonSize === 'extra-small') {
        buttonPaddingY = _sizes.BUTTON_XS_PADDING_Y;
      } else if (buttonSize === 'small') {
        buttonPaddingY = _sizes.BUTTON_SM_PADDING_Y;
      } else {
        buttonPaddingY = _sizes.BUTTON_DEFAULT_PADDING_Y;
      }
      return -parseInt(buttonPaddingY, 10);
    }
    return 0;
  },
  getInsetAdjustment: function getInsetAdjustment(_ref7, _ref8) {
    var buttonUse = _ref7.buttonUse,
        placement = _ref7.placement;
    var computedArrowSize = _ref8.computedArrowSize;

    if (buttonUse === 'transparent' && placement === 'bottom right' && computedArrowSize === 'none') {
      // Account for invisible padding. Inset adjustments are applied twice
      // (once to the tether attachment, once to the target attachment), so
      // we halve our value here.
      return -parseInt(_sizes.BUTTON_DEFAULT_PADDING_X, 10) / 2;
    }
    return 0;
  },
  getWindowListeners: function getWindowListeners() {
    return {
      click: this.handleWindowClick,
      keyup: this.handleWindowKeyUp,
      keydown: this.handleWindowKeyDown
    };
  },
  hasKeyboardFocus: function hasKeyboardFocus() {
    var activeElement = (0, _ActiveElement.getActiveElement)();
    var dropdownNode = document.getElementById(this._dropdownId);
    if (!activeElement) {
      return false;
    }
    if (activeElement === this.state.target) {
      return true;
    } else if (dropdownNode && dropdownNode.contains(activeElement)) {
      return true;
    }
    return false;
  },
  getWindowListenersActive: function getWindowListenersActive() {
    var _props = this.props,
        closeOnOutsideClick = _props.closeOnOutsideClick,
        open = _props.open;

    return closeOnOutsideClick && open;
  },
  handleButtonClick: function handleButtonClick(evt) {
    var _props2 = this.props,
        locked = _props2.locked,
        open = _props2.open,
        onClick = _props2.onClick;

    (0, _Functions.callIfPossible)(onClick, evt);

    if (!locked) {
      var nextOpen = !open;
      this.setIsOpen(nextOpen);
    }
  },
  handleWindowClick: function handleWindowClick(evt) {
    var target = evt.target;

    // Ignore clicks on DOM elements that are no longer in the document, as
    // these can represent "inside" clicks that caused DOM mutation.
    if (!document.body.contains(target)) {
      return;
    }

    // Ignore clicks on the button
    var controlNode = this.state.target;
    if (controlNode && controlNode.contains(target)) {
      return;
    }

    // Ignore clicks on any <label> that contain the button
    var parentEl = controlNode;
    while (parentEl.parentElement) {
      parentEl = parentEl.parentElement;
      if (parentEl.tagName === 'LABEL' && parentEl.contains(target)) {
        return;
      }
    }

    // Ignore clicks on any <label> whose "for" attr points to the button
    var id = controlNode.id;
    if (id) {
      var labelsForControl = document.querySelectorAll('label[for=' + id + ']');
      for (var i = 0; i < labelsForControl.length; i++) {
        if (labelsForControl[i].contains(target)) {
          return;
        }
      }
    }

    // Ignore clicks within the dropdown
    var dropdownNode = document.getElementById(this._dropdownId);
    if (dropdownNode && (0, _EventHandlers.isClickWithinContainer)(evt, dropdownNode)) {
      return;
    }

    this.setIsOpen(false);
  },
  handleWindowKeyUp: function handleWindowKeyUp(evt) {
    if (!this.hasKeyboardFocus()) {
      return;
    }
    var keyCode = evt.keyCode;

    if (keyCode === _KeyCodes.ESC) {
      this.setIsOpen(false);
    }
  },
  handleWindowKeyDown: function handleWindowKeyDown(evt) {
    if (!this.hasKeyboardFocus()) {
      return;
    }
    var onWindowKeyDown = this.props.onWindowKeyDown;

    (0, _Functions.callIfPossible)(onWindowKeyDown, evt);
  },
  setIsOpen: function setIsOpen(nextOpen) {
    var onOpenChange = this.props.onOpenChange;

    if (!onOpenChange) {
      return;
    }
    onOpenChange((0, _SyntheticEvent2.default)(nextOpen));
  },
  focusOnControl: function focusOnControl() {
    // When focusing, we want to avoid scrolling the page
    var _window = window,
        scrollX = _window.scrollX,
        scrollY = _window.scrollY;

    var controlNode = this.state.target;
    if (!controlNode) {
      return;
    }
    controlNode.focus();
    window.scrollTo(scrollX, scrollY);
  },
  reposition: function reposition() {
    if (this._popoverRef) {
      this._popoverRef.reposition();
    }
  },
  computeControlWidth: function computeControlWidth(controlEl) {
    var open = this.props.open;

    if (!controlEl || !open) {
      return 0;
    }
    var exactWidth = controlEl.getBoundingClientRect().width;
    var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
    return roundedWidth - 2; // account for 1px border added by UIPopover
  },
  controlRefCallback: function controlRefCallback(controlRef) {
    this._controlRef = controlRef;
    var controlEl = (0, _reactDom.findDOMNode)(this._controlRef);
    this.setState({
      controlWidth: this.computeControlWidth(controlEl),
      target: controlEl
    });
  },
  popoverRefCallback: function popoverRefCallback(ref) {
    this._popoverRef = ref;
  },
  getButtonClassName: function getButtonClassName(_ref9) {
    var className = _ref9.className,
        multiline = _ref9.multiline,
        open = _ref9.open;

    return (0, _reactUtils.classNames)(className, 'private-button__dropdown-opener', 'uiDropdown__button', {
      'private-button__dropdown-opener--multiline': multiline,
      'private-button__dropdown-opener--open': open
    });
  },
  getDropdownClassName: function getDropdownClassName(_ref10) {
    var dropdownClassName = _ref10.dropdownClassName;

    return (0, _reactUtils.classNames)('private-dropdown', 'uiDropdown__dropdown', dropdownClassName);
  },
  renderButton: function renderButton(_ref11, _ref12) {
    var _useNativeButton = _ref11._useNativeButton,
        ariaPressed = _ref11.ariaPressed,
        buttonSize = _ref11.buttonSize,
        buttonUse = _ref11.buttonUse,
        open = _ref11.open,
        rest = _objectWithoutProperties(_ref11, ['_useNativeButton', 'ariaPressed', 'buttonSize', 'buttonUse', 'open']);

    var computedButtonClassName = _ref12.computedButtonClassName,
        renderedButtonLabel = _ref12.renderedButtonLabel,
        renderedCaret = _ref12.renderedCaret;

    var ButtonType = buttonUse === 'unstyled' ? _UIClickable2.default : _UIButton2.default;
    var buttonProps = buttonUse === 'unstyled' ? {} : {
      _useNativeButton: _useNativeButton,
      size: buttonSize,
      use: buttonUse
    };

    return _react2.default.createElement(
      ButtonType,
      _extends({}, rest, buttonProps, {
        'aria-haspopup': true,
        'aria-owns': this._dropdownId,
        'aria-pressed': typeof ariaPressed === 'boolean' ? ariaPressed : open,
        className: computedButtonClassName,
        onClick: this.handleButtonClick,
        ref: this.controlRefCallback,
        role: 'button'
      }),
      _react2.default.createElement(
        'span',
        { className: 'uiDropdown__buttonContents private-dropdown__button__contents' },
        renderedButtonLabel,
        renderedCaret
      )
    );
  },
  renderButtonLabel: function renderButtonLabel(_ref13) {
    var buttonText = _ref13.buttonText,
        iconName = _ref13.iconName;

    var buttonClassNames = (0, _reactUtils.classNames)('private-dropdown__button-label', 'uiDropdown__buttonLabel', { 'uiDropdown__buttonLabel--no-icon': !iconName && !buttonText });
    var icon = iconName ? _react2.default.createElement(_UIIcon2.default, { className: 'private-dropdown__icon', name: iconName }) : null;
    return _react2.default.createElement(
      'span',
      { className: buttonClassNames },
      icon,
      buttonText == null || buttonText === '' ? '\u200B' : buttonText
    );
  },
  renderCaret: function renderCaret(_ref14) {
    var buttonUse = _ref14.buttonUse,
        caretRenderer = _ref14.caretRenderer;

    return CustomRenderer.render(caretRenderer, { use: buttonUse });
  },
  render: function render() {
    var _props3 = this.props,
        animateOnMount = _props3.animateOnMount,
        animateOnToggle = _props3.animateOnToggle,
        ariaPressed = _props3['aria-pressed'],
        arrowColor = _props3.arrowColor,
        arrowSize = _props3.arrowSize,
        autoPlacement = _props3.autoPlacement,
        buttonSize = _props3.buttonSize,
        buttonText = _props3.buttonText,
        buttonUse = _props3.buttonUse,
        caretRenderer = _props3.caretRenderer,
        children = _props3.children,
        className = _props3.className,
        __closeOnOutsideClick = _props3.closeOnOutsideClick,
        dropdownClassName = _props3.dropdownClassName,
        dropdownContentRef = _props3.dropdownContentRef,
        iconName = _props3.iconName,
        __locked = _props3.locked,
        menuWidth = _props3.menuWidth,
        multiline = _props3.multiline,
        onChangePlacement = _props3.onChangePlacement,
        __onClick = _props3.onClick,
        onFocusLeave = _props3.onFocusLeave,
        __onOpenChange = _props3.onOpenChange,
        onOpenComplete = _props3.onOpenComplete,
        onOpenStart = _props3.onOpenStart,
        __onWindowKeyDown = _props3.onWindowKeyDown,
        open = _props3.open,
        pinToConstraint = _props3.pinToConstraint,
        placement = _props3.placement,
        popoverProps = _props3.popoverProps,
        _useMutationObserver = _props3._useMutationObserver,
        _useNativeButton = _props3._useNativeButton,
        rest = _objectWithoutProperties(_props3, ['animateOnMount', 'animateOnToggle', 'aria-pressed', 'arrowColor', 'arrowSize', 'autoPlacement', 'buttonSize', 'buttonText', 'buttonUse', 'caretRenderer', 'children', 'className', 'closeOnOutsideClick', 'dropdownClassName', 'dropdownContentRef', 'iconName', 'locked', 'menuWidth', 'multiline', 'onChangePlacement', 'onClick', 'onFocusLeave', 'onOpenChange', 'onOpenComplete', 'onOpenStart', 'onWindowKeyDown', 'open', 'pinToConstraint', 'placement', 'popoverProps', '_useMutationObserver', '_useNativeButton']);

    var computedArrowSize = arrowSize || this.getArrowSize({ buttonUse: buttonUse });
    var computedAnimateOnToggle = this.getAnimateOnToggle({ animateOnToggle: animateOnToggle }, { computedArrowSize: computedArrowSize });
    var computedButtonClassName = this.getButtonClassName({
      className: className,
      multiline: multiline,
      open: open
    });
    var computedDropdownClassName = this.getDropdownClassName({
      dropdownClassName: dropdownClassName
    });
    var computedPlacement = this.getPlacement({ placement: placement }, { computedArrowSize: computedArrowSize });
    var computedDistanceAdjustment = this.getDistanceAdjustment({
      buttonSize: buttonSize,
      buttonUse: buttonUse
    });
    var computedInsetAdjustment = this.getInsetAdjustment({ buttonUse: buttonUse, placement: placement }, { computedArrowSize: computedArrowSize });
    var renderedButtonLabel = this.renderButtonLabel({
      buttonText: buttonText,
      iconName: iconName
    });
    var renderedCaret = this.renderCaret({ buttonUse: buttonUse, caretRenderer: caretRenderer });
    var controlWidth = this.getControlWidth();

    return _react2.default.createElement(
      _UIPopover2.default,
      _extends({
        animateOnMount: animateOnMount,
        animateOnToggle: computedAnimateOnToggle,
        arrowColor: arrowColor,
        arrowSize: computedArrowSize,
        autoPlacement: autoPlacement,
        content: _react2.default.createElement(
          'div',
          {
            className: computedDropdownClassName,
            id: this._dropdownId,
            ref: dropdownContentRef,
            style: {
              width: menuWidth || controlWidth,
              minWidth: menuWidth === 'auto' ? controlWidth : null
            }
          },
          children
        ),
        _distanceAdjustment: computedDistanceAdjustment,
        _insetAdjustment: computedInsetAdjustment,
        _useMutationObserver: _useMutationObserver,
        onFocusLeave: onFocusLeave,
        onChangePlacement: onChangePlacement,
        onOpenStart: onOpenStart,
        onOpenComplete: onOpenComplete,
        open: open,
        pinToConstraint: pinToConstraint,
        placement: computedPlacement,
        ref: this.popoverRefCallback
      }, popoverProps),
      _react2.default.createElement(
        _HideFocusOnClick2.default,
        null,
        this.renderButton(_extends({
          _useNativeButton: _useNativeButton,
          ariaPressed: ariaPressed,
          buttonSize: buttonSize,
          buttonUse: buttonUse,
          open: open
        }, rest), { computedButtonClassName: computedButtonClassName, renderedButtonLabel: renderedButtonLabel, renderedCaret: renderedCaret })
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/dropdown/abstract/UIAbstractDropdown.js
// module id = 152
// module chunks = 0